import { render, staticRenderFns } from "./ToolbarSaveContent.vue?vue&type=template&id=9bd868b6&scoped=true&lang=pug&"
import script from "./ToolbarSaveContent.vue?vue&type=script&lang=js&"
export * from "./ToolbarSaveContent.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarSaveContent.vue?vue&type=style&index=0&id=9bd868b6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd868b6",
  null
  
)

/* custom blocks */
import block0 from "@/lang/components/toolbarSaveContent.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fcomponents%2FToolbarSaveContent.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports